<script setup>
import { computed, onMounted } from "vue";
import { RouterView } from "vue-router";
import { useColorMode, useBrowserLocation } from "@vueuse/core";
import { theme } from "ant-design-vue";
import { Toaster } from "@/components/ui/sonner";
import { useUserStore } from "@/store/userStore";
import router from "@/router";
import { isLoggedIn } from "@/services/auth";
import { useUser } from "@/composables/useUser";
import { Loader2 } from "lucide-vue-next";
const user = useUser();

const { system, store } = useColorMode();
const mode = computed(() => (store.value === "auto" ? system.value : store.value));

// Compute the logo URL based on the current color mode
const logoSrc = computed(() =>
  mode.value === "dark"
    ? "https://cdn.aplos-nca.com/assets/MonoLogoWhite.svg"
    : "https://cdn.aplos-nca.com/assets/ColorLogo.svg"
);
onMounted(async () => {
  await user.initialize();
});
</script>

<template>
  <div>    
    <a-config-provider
      :theme="{
        token: {
          colorPrimary: '#16a34a',
          colorSuccess: '#5aa745',
          colorError: '#ff5757',
          colorFillQuaternary: '#EFEFF0',
          ...(mode === 'dark' && {
            colorPrimaryBg: '#0C101D',
            colorBgContainer: '#0d1526',
            colorBorderSecondary: '#1e293b',
            colorBgElevated: '#020817',
            colorFillQuaternary: '#1E293B',
          }),
        },
        algorithm: mode === 'dark' ? theme.darkAlgorithm : theme.defaultAlgorithm,
      }"
    >
      <RouterView />
    </a-config-provider>
    <Toaster :theme="mode" rich-colors position="top-center" />
  </div>
</template>
